import numberToFixed from './numberToFixed'

export default function calcPercentage(partial: number, total: number) {
  if (!total || !partial) {
    return 0
  }

  return Math.min(numberToFixed((100 * partial) / total, 2), 100)
}
